<script setup>
import IconArrowRight from '@/components/svg/IconArrowRight.vue'
const props = defineProps({
  leftTitle: Array,
  keywords: {
    type: String,
    required: true,
  },
  backgroundColor:{
    type: String,
    default: null,
  },
  iconColor:{
    type: String,
    default: '#333333'
  },
  isMobile:{
    type: Boolean,
    default: false,
  }
})

/** 키워드 분해 */
const keywordList = computed(() => {
  return props.keywords.split(',').map(str => str.trim())
})

const firstKeyword = computed(() => keywordList.value[0] || '')
const secondKeyword = computed(() => keywordList.value[1] || '')
const thirdKeyword = computed(() => keywordList.value[2] || '')
</script>
<template>
  <div 
    class="person-keyword__inner"
    :class="{mobile: isMobile}"
  >
    <div
      class="keyword__left-title"
      :class="[backgroundColor, {mobile: isMobile}]"
    >
    <span
      v-for="(str, idx) in props.leftTitle"
      :key="idx"
      class="keyword__left-txt"
      :class="[backgroundColor, {mobile: isMobile}]"
    >
      {{ str }}<br/>
    </span>
    <div class="keyword__left-arrow">
      <IconArrowRight
        :color="iconColor"
      />
    </div>
    </div>

    <div class="keyword__right">
      <div 
        class="guide__circle-box"
        :class="{mobile: isMobile}"
      >
        <div class="circle-box__overlap-group">
          <div class="personality-circle clear">
            <span class="circle__main-txt">
              {{ firstKeyword }}
            </span>
          </div>
          <div class="personality-circle light overlap-circle">
            <span class="circle__main-txt">
              {{ secondKeyword }}
            </span>
          </div>
        <div v-if="thirdKeyword" class="personality-circle clear overlap-circle">
          <span class="circle__main-txt ">
            {{ thirdKeyword }}
          </span>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>